import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const websites = {
  unique_visitors: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/unique_visitors", params),
  page_views: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/page_views", params),
  bounce_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/bounce_rate", params),
  browsers: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/browsers", params),
  devices: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/devices", params),
  countries: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/countries", params),
  activity: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/activity", params),
  operating_systems: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/websites/operating_systems",
      params,
    ),
  traffic_sources: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/traffic_sources", params),
  pages: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/websites/pages", params),
};
